import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { ComplianceSectionTaxonomy } from '@/lib/types';

const BASE = '/api/v1/compliance/clauses';

export function useComplianceSections() {
  return useQuery({
    queryKey: queryKeys.compliance.sections(),
    queryFn: async (): Promise<ComplianceSectionTaxonomy[]> => {
      const response = await apiClient.get<ComplianceSectionTaxonomy[]>(
        `${BASE}/sections/`,
      );
      return Array.isArray(response.data) ? response.data : [];
    },
  });
}
